export default __webpack_public_path__ + "static/media/Grid3.9.ad7a06e9.jpg";